import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import Services from '../services/services';
import BodyContainer from '../ui/BodyContainer';
import viewEventStyles from '../styles/viewEventStyles';
import EventHead from '../ui/viewEventUi/EventHead';
import EventDetailsComp from '../ui/viewEventUi/EventDetails';
import EventDescComp from '../ui/viewEventUi/EventDescComp';
import EventActions from '../ui/viewEventUi/EventActions';
import { defaultImages } from '../constants';
import toast, { Toaster } from 'react-hot-toast';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
// import { getUserBrowserStorage } from '../constants';
import { backArrow } from '../ui/icons';

const useStyles = makeStyles((theme) => viewEventStyles(theme));

function SharedEventPage({ eventId, eventUniqueNo, userDetails, isLogin }) {
  // let { eventId, eventUniqueNo } = useParams();
  const classes = useStyles();
  const history = useHistory();
  // const userDetails = JSON.parse(getUserBrowserStorage('userDetails'));
  const dataFrom = 'UpcomingEvents';
  const pageFrom = 'share_handle';

  const [eventDetails, setEventDetails] = useState({});

  const handleBackButton = () => {
    // history.goBack();
    history.push('/');
  };

  const showLoadToaster = (msg) => {
    toast.dismiss();
    const toastId = toast.loading(msg);
    return toastId;
  };

  const showSuccToaster = (msg, toastId) => {
    toast.success(msg, { id: toastId });
  };

  const showErrToaster = (msg, toastId) => {
    toast.error(msg, { id: toastId });
  };

  const getEventDetails = async (eventId) => {
    const toastId = showLoadToaster('Please wait');
    try {
      const res = await Services.get_event_new(eventId, eventUniqueNo);
      showSuccToaster('Event Details', toastId);
      setEventDetails(res.data.eventDetails[0]);
    } catch (error) {
      showErrToaster('Error getting details', toastId);
    }
  };

  useEffect(() => {
    getEventDetails(eventId);
  }, []);

  const onClickSignIn = () => {
    history.push('/login', {
      dataFrom: pageFrom,
      pathCustom: `/event/share/${eventId}/${eventUniqueNo}`,
    });
  };

  const onClickAddP = () => {
    history.push('/addparticipants', {
      data: eventDetails,
      dataFrom: dataFrom,
    });
  };

  const onClickReserve = () => {
    history.push('/reservebox', { data: eventDetails, dataFrom: dataFrom });
  };

  return (
    <BodyContainer
      title='Event Details'
      icon={userDetails ? backArrow(handleBackButton) : ''}
    >
      <Grid container className={classes.gridOccupy}>
        <Paper elevation={0} className={classes.root}>
          <EventHead
            homeBackgroundImgContainer={classes.homeBackgroundImgContainer}
            imgTitleContainer={classes.imgTitleContainer}
            Image={
              eventDetails?.eventId
                ? eventDetails?.eventLogoUrl
                  ? Services.event_logo_URL() + eventDetails.eventLogoUrl
                  : defaultImages.logo
                : ''
            }
            imageStyle={classes.image}
            homeBackgroundImgCls={classes.homeBackgroundImgCls}
            // homeBackgroundImg={defaultImages.background}
            homeBackgroundImg={
              eventDetails?.eventBanner
                ? Services.event_logo_URL() + eventDetails?.eventBanner
                : ''
            }
            titleContainer={classes.titleContainer}
            titleNstatus={classes.titleNstatus}
            titleStyle={classes.titleStyle}
            eventName={eventDetails?.eventName}
            location={eventDetails?.location}
            statusCont={classes.statusCont}
            activIcon={classes.activIcon}
            activeClass={classes.activeClass}
            dateTimeCont={classes.dateTimeCont}
            dateStyle={classes.date}
            eventDate={eventDetails?.eventDate}
            eventTime={eventDetails?.eventTime}
            eventStatus={eventDetails?.eventStatus}
            expiredIcon={classes.expiredIcon}
            shareIconCls={classes.shareIconCls}
          />

          <div className={classes.bodyContnSyle}>
            <div className={classes.detailsCont}>
              <EventDetailsComp
                fourItemCont={classes.fourItemCont}
                eventType={eventDetails?.eventType}
                eventCapacity={eventDetails?.eventCapacity}
                totalBox={eventDetails?.totalBox}
                publicEvent={eventDetails?.publicEvent}
                participantPerBox={eventDetails?.participantPerBox}
                seatPrice={eventDetails?.seatPrice}
                boxPrice={eventDetails?.boxPrice}
                hostFirstName={eventDetails?.hostFirstName}
                hostLastName={eventDetails?.hostLastName}
                pageFrom={pageFrom}
              />

              <EventDescComp
                mainBody={classes.mainBody}
                layoutImgCont={classes.layoutImgCont}
                eventLayoutUrl={
                  eventDetails?.eventLayoutUrl
                    ? Services.event_logo_URL() + eventDetails?.eventLayoutUrl
                    : `/assets/images/layout${eventDetails?.eventLayoutId_id}.png`
                }
                layoutImg={classes.layoutImg}
                bodyCont={classes.bodyCont}
                head={classes.head}
                actualBody={classes.actualBody}
                eventDescription={eventDetails?.eventDescription}
              />
            </div>
          </div>
        </Paper>
      </Grid>
      <Grid container>
        <EventActions
          actionsCont={classes.actionsCont}
          dummy={classes.dummy}
          editEventBtn={classes.editEventBtn}
          onClickReserve={onClickReserve}
          onClickAddP={onClickAddP}
          onClickSignIn={onClickSignIn}
          eventStatus={eventDetails?.eventStatus}
          isUserId={userDetails?.userId ? true : false}
          isEventPublic={!!(eventDetails?.publicEvent === 'Y')}
          isLogin={isLogin}
          pageFrom={pageFrom}
          allowUsersToReserveBox={eventDetails?.allowUsersToReserveBox}
          eventId={eventId}
          eventUniqueNo={eventUniqueNo}
          isGuestAllowed={eventDetails?.isGuestAllowed}
        />
      </Grid>
      <Toaster position='top-center'></Toaster>
    </BodyContainer>
  );
}

export default SharedEventPage;
